"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setImmediate2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-immediate"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _vue = _interopRequireDefault(require("vue"));
var _common = require("./common");
var IrcClient = _interopRequireWildcard(require("../IrcClient"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** @module */
/** The IRC network instance */
var NetworkState = /*#__PURE__*/function () {
  function NetworkState(id, appState, userDict, bufferDict) {
    var _this = this;
    (0, _classCallCheck2.default)(this, NetworkState);
    // Enumerable properties that become reactive under Vue
    this.id = id;
    this.name = '';
    this.editable_name = false;
    // State of the transport
    this.state = 'disconnected';
    this.state_error = '';
    // Last error from the IRC server. Resets on reconnect
    this.last_error = '';
    this.auto_commands = '';
    this.is_znc = false;
    this.is_bnc = false;
    this.hidden = false;
    this.channel_list = [];
    this.channel_list_state = '';
    // The IRCd type as mentioned in the 002 numeric
    this.ircd = '';
    this.connection = {
      server: '',
      port: 6667,
      tls: false,
      path: '',
      // Server password
      password: '',
      direct: false,
      encoding: 'utf8',
      bncnetid: '',
      nick: ''
    };
    this.settings = {
      show_raw_caps: false
    };
    this.nick = '';
    this.username = '';
    this.gecos = '';
    // SASL password
    this.account = {
      account: '',
      password: ''
    };
    this.password = '';
    this.away = '';
    _vue.default.observable(this);

    // Some non-enumerable properties (vues $watch won't cover these properties)
    (0, _common.def)(this, 'appState', appState, false);
    (0, _common.def)(this, 'userDict', userDict, false);
    (0, _common.def)(this, 'bufferDict', bufferDict, false);
    (0, _common.def)(this, 'frameworkClient', null, true);
    (0, _common.def)(this, 'users', Object.create(null), function (newVal) {
      appState.$set(userDict.networks, _this.id, newVal);
    });

    // Pending prviate messages awaiting whois operator check
    (0, _common.def)(this, 'pendingPms', [], false);
    bufferDict.$set(bufferDict.networks, this.id, []);
  }
  (0, _createClass2.default)(NetworkState, [{
    key: "ircClient",
    get: function get() {
      if (!this.frameworkClient) {
        this.frameworkClient = IrcClient.create(this.appState, this);
      }
      return this.frameworkClient;
    }
  }, {
    key: "buffers",
    get: function get() {
      return this.bufferDict.networks[this.id];
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this$ircClient;
      (_this$ircClient = this.ircClient).connect.apply(_this$ircClient, arguments);
    }
  }, {
    key: "bufferByName",
    value: function bufferByName(name) {
      return this.appState.getBufferByName(this.id, name);
    }
  }, {
    key: "serverBuffer",
    value: function serverBuffer() {
      return this.appState.getBufferByName(this.id, '*');
    }
  }, {
    key: "setting",
    value: function setting(name, val) {
      if (typeof val !== 'undefined') {
        this.appState.$set(this.settings, name, val);
        return val;
      }
      return this.settings[name];
    }
  }, {
    key: "isChannelName",
    value: function isChannelName(input) {
      if (typeof input !== 'string' || !input) {
        return false;
      }
      var chanPrefixes = this.ircClient.network.supports('CHANTYPES') || '#&';
      return chanPrefixes.indexOf(input[0]) > -1;
    }
  }, {
    key: "showServerBuffer",
    value: function showServerBuffer(tabName) {
      var _this2 = this;
      this.appState.$emit('active.component', null);
      this.appState.setActiveBuffer(this.id, this.serverBuffer().name);
      // Hacky, but the server buffer component listens for events to switch
      // between tabs
      (0, _setImmediate2.default)(function () {
        _this2.appState.$emit('server.tab.show', tabName || 'settings');
      });
    }

    /**
     * Check if a nick is exempt from block PM's
     * @param {String} nick of the user to check
     * @returns {Boolean} If the boolean is null a whois check is required
     */
  }, {
    key: "isNickExemptFromPmBlocks",
    value: function isNickExemptFromPmBlocks(nick) {
      // Check if nick is op of shared channel
      var buffers = this.appState.getBuffersWithUser(this.id, nick);
      for (var i = 0; i < buffers.length; i++) {
        var buffer = buffers[i];
        if (buffer.isUserAnOp(nick)) {
          return true;
        }
      }
      var user = this.appState.getUser(this.id, nick);
      if (!user || !user.hasWhois) {
        // if we have not seen or whois the user they might be a network oper
        // so return null then a whois can be performed
        return null;
      }
      if (user.operator) {
        return true;
      }
      return false;
    }
  }, {
    key: "currentUser",
    value: function currentUser() {
      return this.appState.getUser(this.id, this.nick);
    }
  }, {
    key: "userByName",
    value: function userByName(nick) {
      return this.appState.getUser(this.id, nick);
    }
  }]);
  return NetworkState;
}();
exports.default = NetworkState;